module.exports = __webpack_public_path__ + "img/icon-user-white.7b929895.svg";